import Link from 'next/link';

import {
  StyleReviewsSection,
  StyleContainer,
  FooterRoot,
  FooterContent,
  FooterLogoSection,
  FooterAddress,
  FooterSocials,
  FooterDownloadSection,
  FooterDownloadLink,
  FooterCopyright,
} from './style';

import Image from 'next/image';
import InfoSection from './InfoSection/InfoSection';
import { Trans, useTranslation } from 'react-i18next';
import { Tooltip, Typography } from '@mui/material';

import Hepler from '../Helper';

const HoiAnGoReviewsSection = () => {
  return (
    <StyleReviewsSection id="hoiango-reviews-section">
      <StyleContainer maxWidth='xl'>
        <InfoSection />
      </StyleContainer>
    </StyleReviewsSection>
  );
};

const Footer = () => {
  const { t } = useTranslation('common');
  const { t: tAboutUs } = useTranslation('aboutUs');
  return (
    <FooterRoot>
      <StyleContainer maxWidth="xl">
        <FooterContent>
          <FooterLogoSection>
            <Image
              src="/assets/images/logo.png"
              alt="HoiAnGO Logo"
              width={104}
              height={56}
              style={{ objectFit: 'contain' }}
            />
            <FooterAddress>
              <Typography component="p">
                {t('footer.contactInformation.address')}: {tAboutUs('contact_information.address')}
              </Typography>
              <Typography component="p">
                {t('footer.contactInformation.phone')}: <Link href={`tel:${tAboutUs('contact_information.phone').replace('+84(0) ', '0')}`}>{tAboutUs('contact_information.phone')}</Link>
              </Typography>
              <Typography component="p">
                {t('footer.contactInformation.email')}: <Link href={`mailto:${tAboutUs('contact_information.email')}`}>{tAboutUs('contact_information.email')}</Link>
              </Typography>
            </FooterAddress>
            <FooterSocials>
              {[
                {
                  id: "facebook",
                  label: "Facebook",
                  icon: "/assets/images/facebook.png",
                  href: "https://www.facebook.com/hoiangogroup",
                },
                {
                  id: "whatsapp",
                  label: "WhatsApp",
                  icon: "/assets/icons/small-whatsapp.svg",
                  href: "https://wa.me/84905633616",
                },
                {
                  id: "instagram",
                  label: "Instagram",
                  icon: "/assets/images/instagram.png",
                  href: "https://www.instagram.com/hoiango.group",
                },
                {
                  id: "zalo",
                  label: "Zalo",
                  icon: "/assets/icons/zalo.svg",
                  href: "https://zalo.me/0905633616",
                },
              ].map((item) => {
                return (
                  <Tooltip key={item.id} title={item.label} placement='top'>
                    <Link
                      href={item.href}
                      target="_blank"
                      aria-label={item.label}
                      tabIndex={0}
                    >
                      <Image
                        src={item.icon}
                        alt={item.label}
                        width={48}
                        height={48}
                      />
                    </Link>
                  </Tooltip>
                )
              })}
            </FooterSocials>
          </FooterLogoSection>
          <FooterDownloadSection>
            <Typography variant="h2" mb={2}>
              <Trans ns="common" i18nKey="footer.appInformation.title" />
            </Typography>
            <Typography color="white" mb={2}>
              <Trans ns="common" i18nKey="footer.appInformation.description" />
            </Typography>
            <FooterDownloadLink
              href="https://play.google.com/store/apps/details?id=com.hoiango.app"
              target="_blank"
              tabIndex={0}
              aria-label="Download on Google Play Store"
            >
              <Image
                src="/assets/images/playstore.webp"
                alt="Google Play Store"
                style={{ width: 28, height: 28, marginRight: 8 }}
                width={28}
                height={28}
              />
              <Trans ns="common" i18nKey="footer.appInformation.googlePlay" />
            </FooterDownloadLink>
            <FooterDownloadLink
              href="https://apps.apple.com/ph/app/hoiango/id6447431264"
              target="_blank"
              tabIndex={0}
              aria-label="Download on Apple App Store"
            >
              <Image
                src="/assets/images/app-store.webp"
                alt="Apple App Store"
                style={{ width: 28, height: 28, marginRight: 8 }}
                width={28}
                height={28}
              />
              <Trans ns="common" i18nKey="footer.appInformation.appleStore" />
            </FooterDownloadLink>
          </FooterDownloadSection>
        </FooterContent>
        <FooterCopyright>
          <Hepler />
          <Typography component="p">
            <Trans
              ns="common"
              i18nKey="footer.copyright"
              values={{ year: "2025" }}
              components={{
                a1: <Link href="https://k2ktech.vn" target="_blank" style={{ color: 'inherit', textDecoration: 'underline' }} />,
              }}
            />
          </Typography>
          <Link
            href="/terms"
            target="_blank"
            tabIndex={0}
            aria-label="Terms and Conditions"
          >
            <Trans ns="common" i18nKey="terms" />
          </Link>
        </FooterCopyright>
      </StyleContainer>
    </FooterRoot>
  );
};

export {
  HoiAnGoReviewsSection,
  Footer,
};
